/* ==========================================================================
   NaturoTheke — Variantenmischung unter dem Warenkorb-Button

   Die Staffel darueber sagt, WIE VIELE Stueck. Hier waehlt der Kunde, WELCHE:
   drei vom selben oder gemischt aus den anderen Varianten.

   Wichtig fuer das Verstaendnis: solange die Mischung leer ist oder genau der
   gewaehlten Variante entspricht, mischen wir uns NICHT ein — dann legt Dawn
   ganz normal los, und die Options-Apps (Globo, Samita) am selben Button
   behalten ihren Ablauf. Erst wenn der Kunde wirklich mischt, uebernehmen
   wir den Klick und legen alle Stuecke in EINEM Aufruf in den Warenkorb.

   Der Rabatt wird hier nicht berechnet — das macht ein automatischer Rabatt
   im Shopify-Admin.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.customElements || customElements.get('naturo-variant-mix')) return;

  customElements.define(
    'naturo-variant-mix',
    class NaturoVariantMix extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-nvm-row]'));
        if (!this.rows.length) return;

        this.countEl = this.querySelector('[data-nvm-count]');
        this.errorEl = this.querySelector('[data-nvm-error]');
        this.totalEl = this.querySelector('[data-nvm-total]');
        this.submitBtn = this.querySelector('[data-nvm-submit]');
        this.currency = this.dataset.nvmCurrency || '€';

        this.section = this.closest('.shopify-section') || document;
        this.currency = this.dataset.nvmCurrency || '€';
        this.form = this.section.querySelector('product-form form');
        this.tiers = this.section.querySelector('naturo-qty-tiers');
        this.unit = (this.tiers && this.tiers.dataset.nqtUnit) || 'Stück';

        this.bindRows();
        this.bindTierChange();
        this.bindSubmit();
        this.bindAddToCart();
        this.update();
      }

      /* ------------------------------------------------------------- Zustand */

      /* Zielmenge kommt aus der Staffel; ohne Staffel aus dem Mengenfeld. */
      target() {
        if (this.tiers) {
          var active = this.tiers.querySelector('[data-nqt-option].is-active');
          if (active) return parseInt(active.dataset.nqtQty, 10) || 1;
        }
        var input = this.form && this.form.querySelector('[name="quantity"]');
        return parseInt(input && input.value, 10) || 1;
      }

      /* Welche Variante steht gerade oben in der Buy-Box? Dawn schreibt sie
         beim Wechsel in das versteckte Feld. */
      selectedVariant() {
        var idInput = this.form && this.form.querySelector('[name="id"]');
        return idInput && idInput.value ? String(idInput.value) : this.dataset.nvmSelected;
      }

      /* Alle Stufen MIT Rabatt, aufsteigend. Quelle ist die Staffel darueber —
         so bleibt es automatisch richtig, wenn dort Stufen geaendert werden. */
      rabattStufen() {
        if (!this.tiers) return [];
        return Array.from(this.tiers.querySelectorAll('[data-nqt-option]'))
          .map((o) => ({
            qty: parseInt(o.dataset.nqtQty, 10) || 0,
            pct: parseFloat(o.dataset.nqtPct) || 0,
            fixed: parseInt(o.dataset.nqtFixed, 10) || 0
          }))
          .filter((t) => t.qty > 0 && (t.pct > 0 || t.fixed > 0))
          .sort((a, b) => a.qty - b.qty);
      }

      /* "10 %" oder "4,00 €" — je nachdem, wie der Rabatt eingestellt ist. */
      vorteil(stufe) {
        if (stufe.fixed > 0) {
          return (stufe.fixed / 100).toFixed(2).replace('.', ',') + ' ' + this.currency;
        }
        return stufe.pct + ' %';
      }

      picks() {
        return this.rows
          .map((row) => ({
            id: row.dataset.nvmVariant,
            quantity: parseInt(row.querySelector('[data-nvm-input]').value, 10) || 0
          }))
          .filter((item) => item.quantity > 0);
      }

      total() {
        return this.picks().reduce((sum, item) => sum + item.quantity, 0);
      }

      /* Was landet beim Kauf im Warenkorb? Leere Auswahl heisst: die
         Staffelmenge von der oben gewaehlten Variante. Bewusst nur eine
         Stelle dafuer — sonst laufen der eigene Button und der abgefangene
         Klick auf den Hauptbutton irgendwann auseinander. */
      itemsToAdd() {
        var picks = this.picks();
        if (picks.length) return picks;
        var selected = this.selectedVariant();
        return selected ? [{ id: selected, quantity: this.target() }] : [];
      }

      money(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' ' + this.currency;
      }

      priceOf(variantId) {
        var row = this.rows.find((r) => r.dataset.nvmVariant === String(variantId));
        return row ? parseInt(row.dataset.nvmPrice, 10) || 0 : 0;
      }

      /* ------------------------------------------------------------------ UI */

      bindRows() {
        this.addEventListener('click', (event) => {
          var minus = event.target.closest('[data-nvm-minus]');
          var plus = event.target.closest('[data-nvm-plus]');
          if (!minus && !plus) return;

          var input = event.target.closest('[data-nvm-row]').querySelector('[data-nvm-input]');
          var value = parseInt(input.value, 10) || 0;
          input.value = Math.max(0, Math.min(20, plus ? value + 1 : value - 1));
          this.update();
        });

        this.addEventListener('change', (event) => {
          if (!event.target.closest('[data-nvm-input]')) return;
          event.target.value = Math.max(0, Math.min(20, parseInt(event.target.value, 10) || 0));
          this.update();
        });
      }

      bindTierChange() {
        // Wechselt der Kunde die Stufe, aendert sich das Ziel — die Anzeige
        // muss mitgehen, sonst steht dort "3 von 5".
        document.addEventListener('naturo:tier-change', () => this.schedule());

        // Die Variantenauswahl liegt nicht im Formular (Dawn haengt sie ueber
        // das form-Attribut an), deshalb direkt an den Auswahl-Elementen.
        this.section.querySelectorAll('variant-radios, variant-selects').forEach((picker) => {
          picker.addEventListener('change', () => this.schedule());
        });

        if (this.form) {
          this.form.addEventListener('change', () => this.schedule());
        }
      }

      /* Nur ein Timer gleichzeitig — mehrere Quellen melden denselben Wechsel,
         und jede eigene Aktualisierung soll nicht die naechste ausloesen. */
      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(), 300);
      }

      update() {
        var target = this.target();
        var total = this.total();

        this.rows.forEach((row) => {
          var qty = parseInt(row.querySelector('[data-nvm-input]').value, 10) || 0;
          row.classList.toggle('is-picked', qty > 0);
          var minus = row.querySelector('[data-nvm-minus]');
          if (minus) minus.disabled = qty <= 0;
        });

        // Der Zaehler richtet sich nach den RABATTSTUFEN, nicht nach der gerade
        // angeklickten Kachel. Vorher stand bei Stufe "1 Stueck" und zwei
        // gewaehlten Stuecken "2 von 1 — 1 zu viel" — irritierend, denn zu viel
        // ist daran nichts; im Gegenteil, es fuehrt naeher an den Rabatt.
        var stufen = this.rabattStufen();
        var erreicht = null;
        var naechste = null;
        stufen.forEach((t) => {
          if (t.qty <= total) erreicht = t;
          else if (!naechste) naechste = t;
        });

        this.classList.toggle('is-complete', total > 0 && !!erreicht);

        if (this.countEl) {
          if (total === 0) {
            this.countEl.textContent = target + '× die gewählte Variante';
          } else if (!stufen.length) {
            this.countEl.textContent = total + ' ' + this.unit + ' ausgewählt';
          } else if (erreicht && naechste) {
            this.countEl.textContent =
              total + ' ' + this.unit + ' — ' + this.vorteil(erreicht) + ' gesichert · ab ' +
              naechste.qty + ' sind es ' + this.vorteil(naechste);
          } else if (erreicht) {
            this.countEl.textContent = total + ' ' + this.unit + ' — ' + this.vorteil(erreicht) + ' gesichert';
          } else {
            this.countEl.textContent =
              total + ' von ' + naechste.qty + ' — noch ' + (naechste.qty - total) +
              ' für ' + this.vorteil(naechste);
          }
        }

        if (this.totalEl) {
          var summe = this.itemsToAdd().reduce(
            (sum, item) => sum + this.priceOf(item.id) * item.quantity,
            0
          );
          this.totalEl.textContent = this.money(summe);
        }

        this.clearError();
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }

      /* --------------------------------------------- Warenkorb-Anbindung */

      /* Nur uebernehmen, wenn der Kunde wirklich gemischt hat. Sonst laeuft
         alles wie bisher durch Dawn — das haelt den normalen Weg unangetastet. */
      needsInterception() {
        var picks = this.picks();
        if (!picks.length) return false;
        if (picks.length === 1 && picks[0].id === this.selectedVariant() && picks[0].quantity === this.target()) {
          return false;
        }
        return true;
      }

      /* Der eigene Button unten. Er traegt bewusst NICHT die Klasse
         product-form__submit — sonst wuerde ihn unsere eigene Abfangroutine
         und die Listener der Options-Apps mitgreifen. */
      bindSubmit() {
        if (!this.submitBtn) return;
        this.submitBtn.addEventListener('click', () => {
          var items = this.itemsToAdd();
          if (!items.length) {
            this.showError('Bitte wähle mindestens ein Stück aus.');
            return;
          }
          this.addToCart(items, this.submitBtn);
        });
      }

      bindAddToCart() {
        document.addEventListener(
          'click',
          (event) => {
            var button = event.target.closest('product-form .product-form__submit');
            if (!button || button.disabled) return;
            if (!this.section.contains(button)) return;
            if (!this.needsInterception()) return;

            // Ab hier uebernehmen wir — Dawn und die Apps kommen nicht mehr dran.
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            this.addToCart(this.picks(), button);
          },
          true
        );
      }

      setBusy(button, busy) {
        if (!button) return;
        var label =
          button.querySelector('[data-nvm-submit-label]') ||
          button.querySelector('span:not(.visually-hidden)') ||
          button;
        if (busy) {
          button.setAttribute('aria-disabled', 'true');
          button.dataset.nvmLabel = label.textContent;
          label.textContent = '…';
        } else {
          button.removeAttribute('aria-disabled');
          if (button.dataset.nvmLabel) label.textContent = button.dataset.nvmLabel;
        }
      }

      addToCart(items, button) {
        this.clearError();
        this.setBusy(button, true);

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var canRender =
          !!cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

        var body = { items: items };
        if (canRender) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then((response) => response.json())
          .then((parsed) => {
            this.setBusy(button, false);

            if (parsed.status) {
              this.showError(parsed.description || parsed.message);
              return;
            }

            // Zurueck auf null: sonst legt der naechste Klick die Mischung
            // ein zweites Mal dazu.
            this.rows.forEach((row) => {
              row.querySelector('[data-nvm-input]').value = 0;
            });
            this.update();

            if (!canRender) {
              window.location = window.routes.cart_url;
              return;
            }

            // Dawn entfernt diese Klasse sonst in product-form.js; bleibt sie
            // stehen, sucht der Drawer beim Oeffnen den Leer-Zustand und
            // trapFocus() wirft.
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

            try {
              cart.renderContents(parsed);
            } catch (error) {
              console.error('[naturo-variant-mix] Drawer konnte nicht neu gerendert werden:', error);
              window.location.reload();
            }
          })
          .catch((error) => {
            console.error('[naturo-variant-mix] Hinzufuegen fehlgeschlagen:', error);
            this.setBusy(button, false);
            this.showError('Das hat leider nicht geklappt. Bitte versuche es erneut.');
          });
      }
    }
  );
})();
